import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  TicketIcon,
  FolderIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  ViewColumnsIcon,
  UsersIcon,
  UserGroupIcon,
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  ArrowPathIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { useUIStore } from '@/store/uiStore';
import { cn } from '@/utils/cn';
import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api-client';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'Tickets', href: '/tickets', icon: TicketIcon },
  { name: 'Kanban', href: '/kanban', icon: ViewColumnsIcon },
  { name: 'Projects', href: '/projects', icon: FolderIcon },
  { name: 'Sprints', href: '/sprints', icon: ArrowPathIcon },
  { name: 'Issues', href: '/issues', icon: ExclamationTriangleIcon },
  { name: 'Schedule', href: '/schedule', icon: CalendarDaysIcon },
  { name: 'Users', href: '/users', icon: UsersIcon },
  { name: 'Backlog', href: '/backlog', icon: ClipboardDocumentListIcon },
  { name: 'Groups', href: '/groups', icon: UserGroupIcon },
  { name: 'CRM', href: '/crm', icon: UserGroupIcon },
  { name: 'Reports', href: '/reports', icon: ChartBarIcon },
  { name: 'Settings', href: '/settings', icon: Cog6ToothIcon },
];

export function Sidebar() {
  const sidebarOpen = useUIStore((state) => state.sidebarOpen);
  const [crmAccess, setCrmAccess] = useState(false);
  useEffect(() => {
    apiClient.get('/contacts/access').then(res => {
      setCrmAccess(res.data?.has_access || false);
    }).catch(() => setCrmAccess(false));
  }, []);

  return (
    <>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 lg:hidden"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-30 w-64 bg-white border-r border-gray-200 transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        <div className="h-full flex flex-col">
          {/* Logo */}
          <div className="flex items-center justify-center h-16 border-b border-gray-200 px-6">
            <h1 className="text-xl font-bold text-primary-600">
              CORTEX
            </h1>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto py-4">
            <div className="px-3 space-y-1">
              {navigation.filter(item => item.name !== "CRM" || crmAccess).map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md transition-colors',
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    )
                  }
                >
                  {({ isActive }) => (
                    <>
                      <item.icon
                        className={cn(
                          'h-5 w-5 flex-shrink-0',
                          isActive ? 'text-primary-700' : 'text-gray-400'
                        )}
                      />
                      {item.name}
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </nav>

          {/* Footer */}
          <div className="border-t border-gray-200 p-4">
            <p className="text-xs text-gray-500 text-center">
              v1.0.0
            </p>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
